import {Component, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {TranslocoPipe} from '@jsverse/transloco';
import {WorkforceSplit} from '../step-1-1-company-information.types';

@Component({
  selector: 'app-workforce-kpi-card',
  imports: [TranslocoPipe, AppNumberPipe],
  templateUrl: './workforce-kpi-card.component.html',
})
export class WorkforceKpiCardComponent {
  readonly titleKey = input.required<string>();
  readonly split = input.required<WorkforceSplit>();
  readonly digitsInfo = input('1.0-0');
  readonly testId = input.required<string>();
}
